import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  Jaarrekening, Jaarrapportage
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil} from "rxjs";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-toelichting-balans',
  templateUrl: './toelichting-balans.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./toelichting-balans.component.css']
})
export class ToelichtingBalansComponent implements OnInit {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public resultsAppropriationStatementFg = {} as FormGroup;
  public resultsAppropriationProposalStatementFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.resultsAppropriationStatementFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.resultsAppropriationProposalStatementFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const resultaatbestemming = value.rapportage?.jaarrekeningen?.at(0)?.toelichting?.toelichtingBalans?.resultaatbestemming;

    if (resultaatbestemming) {
      const tekstueel = resultaatbestemming.resultaatbestemmingTekstueel;
      if (tekstueel) {
        if (tekstueel.resultsAppropriationStatement) {
          this.resultsAppropriationStatementFg.patchValue(tekstueel.resultsAppropriationStatement);
        }
        if (tekstueel.resultsAppropriationProposalStatement) {
          this.resultsAppropriationProposalStatementFg.patchValue(tekstueel.resultsAppropriationProposalStatement);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.resultsAppropriationStatementFg.updateValueAndValidity({ emitEvent: false });
    this.resultsAppropriationProposalStatementFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          toelichtingBalans: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.toelichtingBalans,
            resultaatbestemming: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.toelichtingBalans?.resultaatbestemming,
              resultaatbestemmingTekstueel: {
                ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.toelichtingBalans?.resultaatbestemming?.resultaatbestemmingTekstueel,
                resultsAppropriationStatement: this.resultsAppropriationStatementFg.value,
                resultsAppropriationProposalStatement: this.resultsAppropriationProposalStatementFg.value,
              }
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}

